// extracted by mini-css-extract-plugin
module.exports = {"tabsWraps":"PageTabs_tabsWraps__3ZeZc","tabItem":"PageTabs_tabItem__3yf1l","title":"PageTabs_title__3Fw8w","tabItemActive":"PageTabs_tabItemActive__1UiDi"};